import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

import ProgramEquipments from "../../program-detail/ProgramEquipments";
import ProgramVideo from "../../program-detail/ProgramVideo";
import ProgramDescription from "../../program-detail/ProgramDescription";
import LoadingAnimation2 from "../../../common/LoadingAnimation2";

import { FaPlus } from "react-icons/fa";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import { Dumbbell } from "../../../common/CustomIcons";

import { AddProgram } from "../../../redux/v2/user/actions";
import { SetSelectedWorkout } from "../../../redux/v2/workout/actions";

import { delay } from "../../../utils";

function ProgramDetail(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const { selectedProgram, setAddedProgram, screenSize, postActionCallback = null } = props;
    const { groupedWorkouts } = props.Workout;
    const { user } = props.User;

    const [activeInfo, setActiveInfo] = useState("info");
    const [showButton, setShowButton] = useState(false);
    const [addingStatus, setAddingStatus] = useState(0); // 0 no, 1 loading, 2 success

    useEffect(() => {
        delay(() => {
            setShowButton(true);
        }, 250);
    }, []);

    useEffect(() => {
        if (screenSize != "xl") {
            setActiveInfo("all");
        } else {
            setActiveInfo("info");
        }
    }, [screenSize]);

    useEffect(() => {
        let temp = user?.selected_program?.split(",") || [];
        if (temp.includes(selectedProgram?.id + (selectedProgram?.level && selectedProgram?.level != 0 ? "-" + selectedProgram?.level : ""))) {
            if (addingStatus == 0) {
                setAddingStatus(3);
            } else if (addingStatus == 2) {
                delay(() => {
                    setAddingStatus(3);
                }, 2000);
            }
        }
    }, [user?.selected_program, addingStatus, groupedWorkouts]);

    const key = "prog-" + selectedProgram?.id + (selectedProgram?.level && selectedProgram?.level != 0 ? "-" + selectedProgram?.level : "");
    const progWorkouts = groupedWorkouts[key] || [];

    const OnboardingAddProgram = async () => {
        if (location.pathname.includes("/user-onboarding") || location.pathname.includes("/user-survey") || location.pathname.includes("/patient-invite") || location.pathname?.includes("/patient-invite")) {
            setAddedProgram();
        } else {
            const toastId = toast.loading("Adding Program...");
            const res = await props.AddProgram(selectedProgram.id, selectedProgram.level);
            if (res.success) {
                toast.success("Program Added", {
                    id: toastId,
                });

                setAddedProgram(true);
            } else {
                toast.error("Failed to add Program", {
                    id: toastId,
                });
            }
        }
    };

    const AddButton = () => {
        return (
            <div id="pd-footer-buttons">
                {selectedProgram?.added && (
                    <div
                        id="pd-fb-back"
                        style={{ width: "100%", maxWidth: "100%" }}
                        onClick={() => {
                            props.back();
                        }}
                    >
                        <div id="pdab-add-btn-wrapper" style={{ height: "100%" }}>
                            <h4 style={{ display: "flex", alignItems: "center" }}>Explore More Programs</h4>
                        </div>
                    </div>
                )}
                {!selectedProgram?.added && (
                    <>
                        <div
                            id="pd-fb-back"
                            onClick={() => {
                                props.back();
                            }}
                        >
                            <div id="pdab-add-btn-wrapper">
                                <div className="btn-wrp flex-c">
                                    <div className="btn-cont">
                                        <IoIosArrowBack />
                                    </div>
                                </div>
                                <h6>BACK</h6>
                            </div>
                        </div>
                        <div
                            id="pdab-add-btn"
                            onClick={async () => {
                                OnboardingAddProgram();
                            }}
                        >
                            <div id="pdab-add-btn-wrapper">
                                <div className="btn-wrp flex-c">
                                    <div className="btn-cont">
                                        <FaPlus />
                                    </div>
                                </div>
                                <h6>ADD PROGRAM</h6>
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    };

    const AddButton2 = () => {
        return (
            <>
                {(addingStatus == 0 || addingStatus == 1) && (
                    // true &&
                    <div
                        id="pdab-back-btn"
                        className="clickable"
                        onClick={() => {
                            // setSelectedProgram(null);
                            if (progWorkouts.length) {
                                props.SetSelectedWorkout(progWorkouts[0]);
                                navigate("/workout?view-type=preview&workout=" + progWorkouts[0].id);
                            }
                        }}
                    >
                        <div id="pdab-back-btn-wrapper">
                            <div className="btn-wrp">
                                <Dumbbell />
                            </div>
                            <h6>TRY IT</h6>
                        </div>
                    </div>
                )}
                <div
                    id="pdab-add-btn"
                    style={addingStatus != 0 && addingStatus != 1 ? { width: "100%" } : {}}
                    className={(addingStatus == 2 || addingStatus == 3) && screenSize == "xl" ? "full-radius" : ""}
                    onClick={async () => {
                        if (addingStatus == 0) {
                            setAddingStatus(1);
                            const res = await props.AddProgram(selectedProgram?.id, selectedProgram?.level);
                            if (res.success) {
                                delay(() => {
                                    setAddingStatus(3);
                                }, 2000);
                                setAddingStatus(2);
                                postActionCallback && postActionCallback(res);
                            } else {
                                setAddingStatus(0);
                                toast.error("Failed to add Program");
                                postActionCallback && postActionCallback(false);
                            }
                        } else if (addingStatus == 3) {
                            if (progWorkouts.length) {
                                props.SetSelectedWorkout(progWorkouts[0]);
                                navigate("/workout?workout=" + progWorkouts[0].id);
                            }
                        }
                    }}
                >
                    {addingStatus == 0 && (
                        <div id="pdab-add-btn-wrapper" className="g-orange">
                            <div className="btn-wrp flex-c">
                                <div className="btn-cont">
                                    <FaPlus />
                                </div>
                            </div>
                            <h6>ADD PROGRAM</h6>
                        </div>
                    )}

                    {addingStatus == 1 && (
                        <div className="flex-c-full">
                            {" "}
                            <LoadingAnimation2 />
                        </div>
                    )}

                    {addingStatus == 2 && (
                        <div className="flex-c-full">
                            <AiOutlineCheckCircle style={{ fontSize: "35px" }} />
                        </div>
                    )}

                    {addingStatus == 3 && (
                        <div className="flex-c-full">
                            <h4>GET STARTED</h4>
                        </div>
                    )}
                </div>
            </>
        );
    };

    return (
        <div id="onb-v2-program-details">
            <div id="onb-v2-program-video">
                <ProgramVideo
                    selectedProgram={selectedProgram}
                    screenSize={screenSize}
                    label={(data) => {
                        return (
                            <>
                                <div className="video-label">
                                    <h6>RECOMMENDED FOR YOU</h6>
                                </div>
                            </>
                        );
                    }}
                />

                <div id="onb-v2-video-detail">
                    <div>
                        {(activeInfo == "all" || activeInfo == "info") && (
                            <>
                                {(location.pathname == "/program-introduction" || location.pathname.includes("/user-onboarding") || location.pathname.includes("/user-survey") || location.pathname.includes("/patient-invite")) ? (
                                    <ProgramDescription
                                        selectedProgram={selectedProgram}
                                        screenSize={screenSize}
                                        progWorkouts={progWorkouts}
                                        actionAdd={
                                            (!selectedProgram?.added && (location.pathname == "/program-introduction" || location.pathname.includes("/user-onboarding") || location.pathname.includes("/user-survey")))
                                                ? async () => {
                                                    OnboardingAddProgram();
                                                }
                                                : null
                                        }
                                        actionGoToPrograms={() => {
                                            props.back();
                                        }}
                                    />
                                ) : location.pathname == "/programs" ? (
                                    <ProgramDescription
                                        selectedProgram={selectedProgram}
                                        screenSize={screenSize}
                                        progWorkouts={progWorkouts}
                                        getStarted={
                                            addingStatus == 3
                                                ? () => {
                                                    if (progWorkouts.length) {
                                                        props.SetSelectedWorkout(progWorkouts[0]);
                                                        navigate("/workout?workout=" + progWorkouts[0].id);
                                                    }
                                                }
                                                : null
                                        }
                                        actionAdd={
                                            addingStatus != 3
                                                ? async () => {
                                                    if (addingStatus == 0) {
                                                        const toastId = toast.loading("Adding Program...");

                                                        setAddingStatus(1);

                                                        const res = await props.AddProgram(selectedProgram?.id, selectedProgram?.level);
                                                        if (res.success) {
                                                            delay(() => {
                                                                setAddingStatus(3);
                                                            }, 2000);

                                                            toast.success("Program Added", {
                                                                id: toastId,
                                                            });
                                                            setAddingStatus(2);
                                                            postActionCallback && postActionCallback(res);
                                                        } else {
                                                            setAddingStatus(0);
                                                            toast.error("Failed to add Program", {
                                                                id: toastId,
                                                            });
                                                            postActionCallback && postActionCallback(false);
                                                        }
                                                    }
                                                }
                                                : null
                                        }
                                        actionGoToWorkouts={() => {
                                            if (progWorkouts.length) {
                                                props.SetSelectedWorkout(progWorkouts[0]);
                                                navigate("/workout?view-type=preview&workout=" + progWorkouts[0].id);
                                            }
                                        }}
                                        actionGoToPrograms={() => {
                                            props.back();
                                        }}
                                    />
                                ) : (
                                    ""
                                )}
                            </>
                        )}

                        {(activeInfo == "all" || activeInfo == "supp") && <ProgramEquipments selectedProgram={selectedProgram} />}
                    </div>
                </div>
            </div>

            {showButton && (
                <div id="program-details-action-button">
                    {(location.pathname == "/program-introduction" || location.pathname.includes("/user-onboarding") || location.pathname.includes("/user-survey")) && <AddButton />}
                    {location.pathname == "/programs" && <AddButton2 />}
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    Workout: state.Workout,
    User: state.User,
});

export default connect(mapStateToProps, {
    AddProgram,
    SetSelectedWorkout,
})(ProgramDetail);
